import {ChangeDetectorRef, Component, HostListener, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {RestBackendService} from "../../services/rest-backend.service";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {GlobalService} from "../../services/global.service";
import {ConfigService} from "../../services/config.service";
import {Meta, Title} from "@angular/platform-browser";
import {ConfirmationService, MessageService} from "primeng/api";

@Component({
  selector: 'app-landing-template',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  templateUrl: './landing-template.component.html',
  styleUrl: './landing-template.component.css'
})
export class LandingTemplateComponent implements OnInit {

  constructor(
      public restBack: RestBackendService,
      public route: Router,
      public global: GlobalService,
      public config: ConfigService,
      private metaService: Meta,
      public activeRoute: ActivatedRoute,
      protected messageService: MessageService,
      protected confirmationService: ConfirmationService,
      protected meta: Meta,
      @Inject(LOCALE_ID) public locale: string,
      public cdr: ChangeDetectorRef,
      public titleService:Title
  ) {
  }
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    let keyPressed = event.keyCode;
    if (keyPressed === 119) {
      debugger;
    }
  }
  ngAfterContentInit(): void {

  }
  ngOnInit(): void {

  }

  getDirection(): string {
    if (this.locale == "fa") {
      return "rtl";
    } else {
      return "ltr";
    }
  }


}
